import {Injectable, Injector} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";
import {CustomReportConfigSearchData} from "./custom-report-config.data";

@Injectable()
export class CustomReportConfigSearchModel extends SearchModel<CustomReportConfigSearchData> {

    constructor(injector: Injector) {
        super(injector, CustomReportConfigSearchData);
    }

    override getIdentifierField(): string {
        return "id";
    }
}
